import { entryPortals } from "@/mocks/archiveEntries";

const EntryPortal = () => {
  return (
    <section id="portal" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="reveal inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <span className="h-px w-8 bg-primary-400" />
              资源入口
            </span>
            <h2 className="reveal mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              从合适的入口进入你的留档记录
            </h2>
            <p className="reveal mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              三条常用路径覆盖绝大多数回看场景：想按阶段看整体、想按索引集中核对，或想直接进入成套归档的专题。
            </p>
          </div>
          <div className="reveal flex items-center gap-3 rounded-lg border border-background-300 bg-background-50 px-5 py-4 lg:shrink-0">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-2xl text-secondary-700">
              <i className="ri-flow-chart" />
            </span>
            <div className="text-sm">
              <div className="font-medium text-foreground-900">入口互通</div>
              <div className="text-foreground-500">不同路径指向同一套留档数据</div>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-14 md:gap-8 md:grid-cols-2 lg:grid-cols-3">
          {entryPortals.map((portal) => (
            <a
              key={portal.id}
              href="#archive"
              className="reveal group flex flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="relative h-52 w-full overflow-hidden md:h-56">
                <img
                  src={portal.image}
                  alt={`${portal.keyword}入口示意图`}
                  title={`黑料看料 ${portal.keyword}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
                <span className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1.5 text-xs font-medium text-foreground-900 backdrop-blur-sm">
                  <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                    <i className={portal.icon} />
                  </span>
                  {portal.keyword}
                </span>
                <span className="absolute bottom-4 left-4 right-4 text-xs text-background-200">
                  {portal.meta}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {portal.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {portal.desc}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600">
                  进入检索
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EntryPortal;